import { number } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const DOT_SHAPE = { cx: number, cy: number, r: number };
var ChartAxisType;
(function (ChartAxisType) {
    ChartAxisType["CATEGORY"] = "category";
    ChartAxisType["NUMBER"] = "number";
})(ChartAxisType || (ChartAxisType = {}));
var ChartCurveType;
(function (ChartCurveType) {
    ChartCurveType["BASIS"] = "basis";
    ChartCurveType["BASIS_CLOSED"] = "basisClosed";
    ChartCurveType["BASIS_OPEN"] = "basisOpen";
    ChartCurveType["LINEAR"] = "linear";
    ChartCurveType["LINEAR_CLOSED"] = "linearClosed";
    ChartCurveType["MONOTONE"] = "monotone";
    ChartCurveType["MONOTONE_X"] = "monotoneX";
    ChartCurveType["MONOTONE_Y"] = "monotoneY";
    ChartCurveType["NATURAL"] = "natural";
    ChartCurveType["STEP"] = "step";
    ChartCurveType["STEP_AFTER"] = "stepAfter";
    ChartCurveType["STEP_BEFORE"] = "stepBefore";
})(ChartCurveType || (ChartCurveType = {}));
var ChartLayout;
(function (ChartLayout) {
    ChartLayout["HORIZONTAL"] = "horizontal";
    ChartLayout["VERTICAL"] = "vertical";
})(ChartLayout || (ChartLayout = {}));
var ChartXAxisOrientation;
(function (ChartXAxisOrientation) {
    ChartXAxisOrientation["BOTTOM"] = "bottom";
    ChartXAxisOrientation["TOP"] = "top";
})(ChartXAxisOrientation || (ChartXAxisOrientation = {}));
var ChartYAxisOrientation;
(function (ChartYAxisOrientation) {
    ChartYAxisOrientation["LEFT"] = "left";
    ChartYAxisOrientation["RIGHT"] = "right";
})(ChartYAxisOrientation || (ChartYAxisOrientation = {}));
var ChartClickType;
(function (ChartClickType) {
    ChartClickType["ACTIVE_DOT"] = "activeDot";
    ChartClickType["AREA"] = "area";
    ChartClickType["BAR"] = "bar";
    ChartClickType["CHART"] = "chart";
    ChartClickType["DOT"] = "dot";
    ChartClickType["LEGEND"] = "legend";
    ChartClickType["LINE"] = "line";
    ChartClickType["PIE"] = "pie";
})(ChartClickType || (ChartClickType = {}));
var ChartAlignment;
(function (ChartAlignment) {
    ChartAlignment["BOTTOM"] = "bottom";
    ChartAlignment["CENTER"] = "center";
    ChartAlignment["LEFT"] = "left";
    ChartAlignment["MIDDLE"] = "middle";
    ChartAlignment["RIGHT"] = "right";
    ChartAlignment["TOP"] = "top";
})(ChartAlignment || (ChartAlignment = {}));
var ChartDynamicRenderType;
(function (ChartDynamicRenderType) {
    ChartDynamicRenderType["ACTIVE_DOT"] = "activeDot";
    ChartDynamicRenderType["DOT"] = "dot";
    ChartDynamicRenderType["TOOLTIP"] = "tooltip";
})(ChartDynamicRenderType || (ChartDynamicRenderType = {}));
var ChartLegendType;
(function (ChartLegendType) {
    ChartLegendType["CIRCLE"] = "circle";
    ChartLegendType["CROSS"] = "cross";
    ChartLegendType["DIAMOND"] = "diamond";
    ChartLegendType["LINE"] = "line";
    ChartLegendType["PLAINLINE"] = "plainline";
    ChartLegendType["RECT"] = "rect";
    ChartLegendType["SQUARE"] = "square";
    ChartLegendType["STAR"] = "star";
    ChartLegendType["TRIANGLE"] = "triangle";
    ChartLegendType["WYE"] = "wye";
})(ChartLegendType || (ChartLegendType = {}));
var ChartType;
(function (ChartType) {
    ChartType["AREA"] = "area";
    ChartType["BAR"] = "bar";
    ChartType["COMPOSED"] = "composed";
    ChartType["LINE"] = "line";
    ChartType["PIE"] = "pie";
})(ChartType || (ChartType = {}));
export { ChartAlignment, ChartAxisType, ChartClickType, ChartCurveType, ChartDynamicRenderType, ChartLayout, ChartLegendType, ChartType, ChartXAxisOrientation, ChartYAxisOrientation, DOT_SHAPE, };
//# sourceMappingURL=base-chart-constants.js.map